import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"

import MuiTextField from "components/MuiTextField"
import { ProjectFormPageProps } from "components/ProjectForm"
import RadioGroup from "components/RadioGroup/RadioGroup"
import { YES_NO_OPTIONS } from "enums/dropdownValues"
import ProjectFormFooter from "../../components/ProjectFormFooter"
import PaymentTerms from "./PaymentTerms"
import usePaymentDetails, { EPaymentDetailsFields } from "./usePaymentDetails"
import { EProjectFormPages } from "components/ProjectForm/config"

const PaymentDetails = (props: ProjectFormPageProps) => {
    const { states, functions } = usePaymentDetails(props)
    const { formik, showPaymentTerms } = states

    const showError = formik.submitCount > 0
    const isLastPage = props.pages?.[props.pages.length - 1] === EProjectFormPages.PAYMENT_DETAILS
    const submitBtnText = isLastPage ? "Submit" : "Next"

    return (
        <>
            <Box
                display={"flex"}
                flexDirection={"column"}
                gap={4}
                className="custom-scrollbar"
                maxHeight={"65vh"}
                padding={"var(--mui-modal-padding)"}
                sx={{
                    overflowY: "auto",
                }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Box display={"flex"} flexDirection={"column"} gap={1}>
                            <Typography fontSize={"14px"} variant="label" textTransform={"none"}>
                                Specify payment terms (by agreement)?*
                            </Typography>
                            <RadioGroup
                                options={YES_NO_OPTIONS}
                                name={EPaymentDetailsFields.SPECIFY_PAYMENT_TERMS}
                                value={formik.values[EPaymentDetailsFields.SPECIFY_PAYMENT_TERMS]}
                                onSelect={(value: any) => {
                                    formik.setFieldValue(EPaymentDetailsFields.SPECIFY_PAYMENT_TERMS, value)
                                    functions.saveFormValuesToRedux(value, "specify_payment_terms")
                                }}
                            />
                            {showError && Boolean(formik.errors[EPaymentDetailsFields.SPECIFY_PAYMENT_TERMS]) && (
                                <Typography color="error" fontSize="12px">
                                    Please specify payment terms
                                </Typography>
                            )}
                        </Box>
                    </Grid>
                    {showPaymentTerms && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Box display={"flex"} flexDirection={"column"} gap={1}>
                                <Typography fontSize={"14px"} variant="label" textTransform={"none"}>
                                    Total amount to be received with GST (in ₹)*
                                </Typography>
                                <MuiTextField
                                    placeholder="Enter Amount"
                                    size="large"
                                    type="number"
                                    value={formik.values[EPaymentDetailsFields.TOTAL_AMOUNT]}
                                    onChange={e => {
                                        formik.setFieldValue(EPaymentDetailsFields.TOTAL_AMOUNT, e.target.value)
                                        functions.saveFormValuesToRedux(e.target.value, "total_amount")
                                    }}
                                    error={showError && Boolean(formik.errors[EPaymentDetailsFields.TOTAL_AMOUNT])}
                                />
                            </Box>
                        </Grid>
                    )}
                </Grid>

                {showPaymentTerms && (
                    <PaymentTerms
                        formik={formik}
                        financeTicketId={props.commonFormData?.common?.finance_ticket_id}
                        showEvidenceUpload={false}
                    />
                )}
            </Box>

            <ProjectFormFooter
                handleCloseForm={props.handleCloseForm}
                handleSubmit={() => formik.handleSubmit()}
                isLoading={states.isAddingPaymentTerms || states.isUpdatingPageData || formik.isSubmitting}
                submitButtonText={submitBtnText}
            />
        </>
    )
}

export default PaymentDetails
